import Scene = Phaser.Scene;
import {TwoOptionsPanel} from "@/scenes.ui/two-options-panel";
import {Tr} from "@/i18n/i18n";

export class IntroPanel extends TwoOptionsPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, subtitle: string,
                atlasKey: string | undefined, iconKey: string, blockFirstText: string, blockSecondText: string,
                onAcceptCallback: () => unknown) {
        super(scene, canvas, title, subtitle, atlasKey, iconKey, blockFirstText, blockSecondText, onAcceptCallback, Tr('dalee'));
    }

}
